import axios from 'axios';
import { getMolecularCdnUrl } from './get-molecular-cdn-url';
import { reportErrorSentry } from './report-error-sentry';
const handleErrorInRetrievingExternalConfig = (): null => {
  console.error('Error retrieving Volkswagen Vilma service config provider.');
  return null;
};

export const getVilmaData = async (frame: string) => {
  const molecularUrl = getMolecularCdnUrl();
  let dataRes: any;
  await axios.get(`${molecularUrl}/request-vilma-frame.php?frame=${frame}`).then(data => dataRes = data)
    .catch((error) => {
      reportErrorSentry(error);
      return null;
    })
  return dataRes;
}
